import { checkDefined, IllegalArgumentError } from 'faro-common-model';
/**
 * Validates and normalizes the provided raw {@link LocationSearchResult}
 * @param source the source object to convert from
 */
export function toLocationSearchResult(source) {
    return {
        code: checkDefined(source.code, 'LocationSearchResult', 'code'),
        matched: checkDefined(source.matched, 'LocationSearchResult', 'matched'),
    };
}
/**
 * Validates and normalizes the provided raw {@link ActivityCostWithLocation}
 * @param source the source object to convert from
 */
export function toActivityCostWithLocation(source) {
    const locationSearchResults = checkDefined(source.locationSearchResults, 'ActivityCostWithLocation', 'locationSearchResults');
    if (!Array.isArray(locationSearchResults)) {
        throw new IllegalArgumentError(`Invalid object [ActivityCostWithLocation]. Property locationSearchResults must be an array`);
    }
    return {
        ...toActivityCost(source),
        locationSearchResults: source.locationSearchResults.map(source => toLocationSearchResult(source)),
    };
}
/**
 * Validates and normalizes the provided raw {@link ActivityCost}
 * @param source The source object to convert from
 */
export function toActivityCost(source) {
    return {
        activityId: checkDefined(source.activityId, 'ActivityCost', 'activityId'),
        assessmentMeasurementId: checkDefined(source.assessmentMeasurementId, 'ActivityCost', 'assessmentMeasurementId'),
        cost: source.cost,
    };
}
//# sourceMappingURL=activity-cost.js.map